import React, { useEffect, useState } from "react";
import GoogleMapContainerV2 from "./GoogleMapContainerv2";
import { InsuranceMonitoringBadge } from "../../Utils/TableColumnDefs";
import { BlurWrapperWithSpan, Legend } from "../../Utils/CustomComponent";

const PropertyInfoTab = ({ insuranceInfo, isABorrower = false }) => {
  const [selectedProperty, setSelectedProperty] = useState(insuranceInfo?.[0]);

  const handlePropertyClick = (property) => {
    setSelectedProperty(property);
  };
  useEffect(() => {
    setSelectedProperty(insuranceInfo?.[0]);
  }, [insuranceInfo]);
  return (
    <>
      <div className="row">
        {/* Property List */}
        <div className="col-3">
          <table className="table table-bordered h-100 ">
            <tbody className="">
              <tr style={{ height: "10px" }}>
                <th>Property List</th>
              </tr>
              <tr>
                <td>
                  <div className="row">
                    <section className="col ps-5">
                      {insuranceInfo?.length
                        ? insuranceInfo?.map((property, index) => (
                            <BlurWrapperWithSpan>
                              <button
                                key={index}
                                className={`btn border w-100 d-flex rounded-0 mb-4 ${
                                  selectedProperty === property
                                    ? "text-primary"
                                    : ""
                                }`}
                                onClick={() => handlePropertyClick(property)}
                              >
                                <span className="me-4">
                                  {property["Property Address"]}
                                </span>
                                <InsuranceMonitoringBadge
                                  props={{
                                    value: [property[" "]],
                                  }}
                                  borrower={isABorrower}
                                  disableOnClick={true}
                                />
                              </button>
                            </BlurWrapperWithSpan>
                          ))
                        : "No Properties Available"}
                    </section>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Property Details */}
        {selectedProperty && (
          <div className="col-9">
            {/* Insurance Monitoring */}
            <div className="row col-12">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <table className="table table-bordered h-100 ">
                  <tbody className="text-center">
                    <tr>
                      <td>
                        <div className="row">
                          <section className="col ps-5">
                            <th className="d-flex justify-content-between">
                              Insurance Monitoring
                            </th>
                          </section>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="row">
                          <section className="col ps-5 row">
                            <div className="col-6">
                              <div className="loaninsuranceinfo text-start">
                                <p className="mb-0 pb-0">Policy Expires</p>
                                <p>
                                  <BlurWrapperWithSpan>
                                    <b>
                                      {selectedProperty?.[
                                        "Cancel / Renewal Date"
                                      ]
                                        ? selectedProperty?.[
                                            "Cancel / Renewal Date"
                                          ]
                                        : "-"}
                                    </b>
                                  </BlurWrapperWithSpan>
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="loaninsuranceinfo text-start">
                                <p className="mb-0 pb-0">Policy Number</p>
                                <p>
                                  <BlurWrapperWithSpan>
                                    <b>
                                      {selectedProperty?.["Policy Number"]
                                        ? selectedProperty?.["Policy Number"]
                                        : "-"}
                                    </b>
                                  </BlurWrapperWithSpan>
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="loaninsuranceinfo text-start">
                                <p className="mb-0 pb-0">Agent</p>
                                <p>
                                  <BlurWrapperWithSpan>
                                    <b>
                                      {selectedProperty?.["Carrier"]
                                        ? selectedProperty?.["Carrier"]
                                        : "-"}
                                    </b>
                                  </BlurWrapperWithSpan>
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="loaninsuranceinfo text-start">
                                <p className="mb-0 pb-0">Coverage Amount</p>
                                <p>
                                  <BlurWrapperWithSpan>
                                    <b>
                                      {selectedProperty?.["Coverage Amount"]
                                        ? selectedProperty?.["Coverage Amount"]
                                        : "-"}
                                    </b>
                                  </BlurWrapperWithSpan>
                                </p>
                              </div>{" "}
                            </div>
                          </section>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 border p-3">
                <Legend1 />
              </div>
            </div>
            {/* Property Map */}
            <div className="col-12">
              <table className="table table-bordered h-100">
                <tbody className="text-center">
                  <tr>
                    <td>
                      <div className="row">
                        <section className="col pe-5">
                          <th className="d-flex justify-content-between">
                            <span>Property Map</span>
                            <BlurWrapperWithSpan>
                              <span>
                                {selectedProperty
                                  ? selectedProperty?.["Property Address"]
                                  : ""}
                              </span>
                            </BlurWrapperWithSpan>
                          </th>
                        </section>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row">
                        <section className="col pe-5">
                          <div className="pt-5">
                            <GoogleMapContainerV2
                              address={`${selectedProperty?.["Property Address"]}`}
                            />
                          </div>
                        </section>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PropertyInfoTab;

const Legend1 = () => {
  const legendItems = [
    { label: "Current", color: "green" }, // Bootstrap green
    { label: "Expiring in 30 Days", color: "yellow" }, // Bootstrap yellow
    { label: "No Proof / Lapse of Insurance", color: "#fd7e14" }, // Bootstrap orange
    { label: "Forced Placed Current", color: "black" }, // Black
    { label: "Forced Placed Expires in 30 days", color: "red" }, // Bootstrap red
  ];

  return (
    <div className="card p-3 border-0" style={{ maxWidth: "400px" }}>
      {legendItems.map((item, idx) => (
        <div key={idx} className="d-flex align-items-center mb-2">
          <div
            className="me-2"
            style={{
              width: "40px",
              height: "14px",
              backgroundColor: item.color,
              borderRadius: "3px",
            }}
          ></div>
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};
